/* trasseapp.com routes. Each page is its own chunk, so signing in to the
   dashboard never downloads the marketing site and vice versa. */
import React, { Suspense, lazy } from 'react';
import SiteLayout from './SiteLayout';

const pages = {
  Home: lazy(() => import('./pages/Home')),
  HowItWorks: lazy(() => import('./pages/HowItWorks')),
  Schools: lazy(() => import('./pages/Schools')),
  Parents: lazy(() => import('./pages/Parents')),
  Drivers: lazy(() => import('./pages/Drivers')),
  ZanaPage: lazy(() => import('./pages/ZanaPage')),
  Pricing: lazy(() => import('./pages/Pricing')),
  Families: lazy(() => import('./pages/Families')),
  Questions: lazy(() => import('./pages/Questions')),
  Book: lazy(() => import('./pages/Book')),
  Thanks: lazy(() => import('./pages/Thanks')),
  SignIn: lazy(() => import('./pages/SignIn')),
  About: lazy(() => import('./pages/About')),
  Safety: lazy(() => import('./pages/Safety')),
  Contact: lazy(() => import('./pages/Contact')),
  NotFound: lazy(() => import('./pages/NotFound')),
};
export type SitePageName = keyof typeof pages;

/** Address → page, for App.tsx. */
export const SITE_PAGES: { path: string; page: SitePageName }[] = [
  { path: '/', page: 'Home' },
  { path: '/how-it-works', page: 'HowItWorks' },
  { path: '/schools', page: 'Schools' },
  { path: '/parents', page: 'Parents' },
  { path: '/drivers', page: 'Drivers' },
  { path: '/zana', page: 'ZanaPage' },
  { path: '/pricing', page: 'Pricing' },
  { path: '/trasse-families', page: 'Families' },
  { path: '/questions', page: 'Questions' },
  { path: '/book', page: 'Book' },
  { path: '/thanks', page: 'Thanks' },
  { path: '/sign-in', page: 'SignIn' },
  { path: '/about', page: 'About' },
  { path: '/safety', page: 'Safety' },
  { path: '/contact', page: 'Contact' },
];

/** Blank paper while a page's chunk arrives (usually instant). */
const Wait: React.FC = () => <div style={{ minHeight: '100vh', background: '#F6F5F1' }} />;

export const SitePageRoute: React.FC<{ page: SitePageName }> = ({ page }) => {
  const P = pages[page];
  return (
    <SiteLayout families={page === 'Families'} bare={page === 'SignIn'}>
      <Suspense fallback={<Wait />}><P /></Suspense>
    </SiteLayout>
  );
};
